import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  confirmPasswordReset,
  reauthenticateWithCredential,
  updatePassword,
  EmailAuthProvider,
} from "firebase/auth";
import { auth } from "../../../firebase/firebaseConfig";
import { getUserById } from "../../../firebase/queries";
import {
  getPropertyInvitedMemberCollectionRef,
  getPropertyInvitedMemberRef,
  getPropertyMemberRef,
  getPropertyRef,
  getUserCollectionRef,
  getUserRef,
} from "../../../firebase/collectionReferences";
import {
  arrayUnion,
  deleteDoc,
  getDoc,
  getDocs,
  query,
  runTransaction,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
// Login
export async function signIn({ email, password }) {
  const { user } = await signInWithEmailAndPassword(
    auth,
    email,
    password
  ).catch((error) => {
    return Promise.reject(error);
  });

  if (user) {
    const userResponse = await getUserById(user.uid);
    const userObj = {
      ...userResponse,
      id: user.uid,
      accessToken: user.accessToken,
    };
    return Promise.resolve(userObj);
  }
}

// ForgotPassword Link
export async function sendResetLink(email) {
  let response = sendPasswordResetEmail(auth, email);
  return response;
}

// Reset Passowrd
export async function resetPassword(code, pass) {
  let response = confirmPasswordReset(auth, code, pass);
  return response;
}

// Change/Update Passowrd
export async function newPassword(password) {
  const user = auth.currentUser;
  const credential = EmailAuthProvider.credential(user.email, password.oldpass);

  let response = reauthenticateWithCredential(user, credential)
    .then((res) => {
      let updatePassRes = updatePassword(user, password.confirm)
        .then((res) => {
          return { success: true, message: "Password updated successfully!" };
        })
        .catch((err) => {
          return { success: false, error: err };
        });

      return updatePassRes;
    })
    .catch((err) => {
      return { success: false, error: err };
    });

  return response;
}

export async function assignPropertyIfMemberExist(
  email,
  propertyId,
  fixedMember = false
) {
  const userRef = getUserCollectionRef();
  const userExist = (
    await getDocs(query(userRef, where("email", "==", email)))
  ).docs
    .map((x) => ({ uid: x.id, ...x.data() }))
    .pop();

  if (!userExist) return false;

  return await createMember({ ...userExist, propertyId }, false, fixedMember);
}

export async function createMember(member, isSignup = true, fixedMember) {
  const { email, name, propertyId } = member;

  const propertyRef = getPropertyRef(propertyId);
  const property = (await getDoc(propertyRef)).data();
  const invitedCollectionMemberRef =
    getPropertyInvitedMemberCollectionRef(propertyRef);
  const invitedMember = (
    await getDocs(
      query(invitedCollectionMemberRef, where("email", "==", email))
    )
  ).docs
    .map((x) => ({ id: x.id, ...x.data() }))
    .pop();
  let user = member;

  const userRef = getUserRef(user.uid);
  await setDoc(
    userRef,
    {
      name,
      email,
      id: user.uid,
      assigned_property_ids: arrayUnion(propertyId),
      companyId: property.companyId,
      companyIds: arrayUnion(property.companyId),
      createdAt: serverTimestamp(),
    },
    { merge: true }
  );

  const propertyMemberRef = getPropertyMemberRef(propertyRef, user.uid);
  await setDoc(
    propertyMemberRef,
    {
      name: name,
      email: email,
      role: invitedMember.role,
      invitedBy: invitedMember.invitedBy,
      createdAt: serverTimestamp(),
    },
    { merge: true }
  );

  if (invitedMember?.role?.slug === "admin") {
    await updateDoc(propertyRef, {
      admins: arrayUnion(user.uid),
    });
  }

  const invitedMemberRef = getPropertyInvitedMemberRef(
    propertyRef,
    invitedMember.id
  );
  await deleteDoc(invitedMemberRef);
  return { user, accessToken: user.accessToken };
}
